import {
  Arrange,
  Button,
  IconButton,
  Link,
  Spacer,
  SvgReplay,
  TextInput,
} from '@loomhq/lens';
import cn from 'classnames';
import React, { useState } from 'react';

import {
  EMAIL_SIGNUP_BUTTON_CLICKED,
  END_OF_VIDEO_EMAIL_SIGNUP_FORM_CLICKED,
  SIGNUP_EMAIL_FIELD_CLICKED,
} from 'constants/events';
import { LOOM_URI, ROOT_PAGE, SIGNUP_PAGE } from 'constants/routes';

import * as analytics from '../../../../utilities/analytics';

import styles from './styles.module.less';

function ButtonAction() {
  function handleClick() {
    window.open(SIGNUP_PAGE, '_blank');

    analytics.track(EMAIL_SIGNUP_BUTTON_CLICKED, {
      source: 'End of Video Nudge',
    });
  }

  return (
    <Button variant="primary" onClick={handleClick}>
      Get Loom for Free
    </Button>
  );
}

function FormAction({ email, setEmail }) {
  const signupRoute = email
    ? `${SIGNUP_PAGE}?invitee_email=${encodeURIComponent(email)}`
    : `${SIGNUP_PAGE}`;

  function handleInputEvent() {
    analytics.track(SIGNUP_EMAIL_FIELD_CLICKED, {
      source: 'end-of-video-nudge',
    });
  }

  function handleSubmitEvent() {
    analytics.track(END_OF_VIDEO_EMAIL_SIGNUP_FORM_CLICKED);
  }

  return (
    <Arrange
      width="100%"
      justifyContent="stretch"
      columns="2fr 1fr"
      gap="small"
      maxWidth="500px"
    >
      <TextInput
        placeholder="Enter your email to sign up"
        onChange={e => setEmail(e.target.value)}
        value={email}
        className={styles.emailInput}
        onFocus={handleInputEvent}
      />
      <a
        href={signupRoute}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleSubmitEvent}
      >
        <Button variant="primary" hasFullWidth>
          Sign up
        </Button>
      </a>
    </Arrange>
  );
}

// 50px: Height of control bar - control-bar/styles.less
// 28px: Height of emoji bar (lg) - emoji-bar/styles.less
function SignupNudge({
  hasLink,
  flagValue,
  fromEmbedToSharePage,
  onSharePage,
  onWatchAgainClick,
}) {
  const [email, setEmail] = useState('');

  const videoLink = window.loomSSRVideo?.id
    ? `${LOOM_URI}/share/${window.loomSSRVideo.id}?fromEmbedSignupNudge=1`
    : null;

  let title = '';

  if (flagValue === 'variant-1') {
    if (onSharePage) {
      title = 'Record your first Loom in seconds';
    } else {
      title = 'Get Loom to become faster than typing';
    }
  } else {
    title = 'Get Loom for free and become faster than typing.';
  }

  const showWatchAgainLink =
    !hasLink && videoLink && !fromEmbedToSharePage && !onSharePage;

  return (
    <div>
      <div
        className={cn('watch-again-cta', styles.signupNudgeContainer)}
        style={{ cursor: 'default' }}
      >
        <div
          className={styles.signupNudgeModalContainer}
          style={{ display: 'flex' }}
        >
          <h1 className={styles.nudgeTitle}>{title}</h1>
          <Spacer bottom="medium" />

          {flagValue === 'variant-1' ? (
            <ButtonAction />
          ) : (
            <FormAction email={email} setEmail={setEmail} />
          )}
          <Spacer bottom="medium" />

          {showWatchAgainLink && (
            <Link
              className={styles.nudgeLink}
              href={videoLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton
                size="small"
                altText="watch again"
                icon={<SvgReplay />}
              />
              Watch again on Loom.com
            </Link>
          )}
          {(fromEmbedToSharePage || onSharePage) && (
            <Link
              className={styles.nudgeLink}
              href={ROOT_PAGE}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to Loom.com
            </Link>
          )}
        </div>
      </div>
      <div className={cn('watch-again-cta', styles.signupNudgeWatchAgain)}>
        <div
          className={styles.signupNudgeWatchAgainText}
          onClick={onWatchAgainClick}
        >
          <IconButton
            size="small"
            icon={<SvgReplay />}
            altText="watch again"
            iconColor="white"
          />
          <div>Watch again</div>
        </div>
      </div>
    </div>
  );
}

export default SignupNudge;
